module.exports = "/_next/static/images/btc-146c94339b644c6da1ce16f1ffb1d9de.svg";